import { render, staticRenderFns } from "./examinationFooter.vue?vue&type=template&id=5936d788&scoped=true&"
import script from "./examinationFooter.vue?vue&type=script&lang=js&"
export * from "./examinationFooter.vue?vue&type=script&lang=js&"
import style0 from "./examinationFooter.vue?vue&type=style&index=0&id=5936d788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936d788",
  null
  
)

component.options.__file = "examinationFooter.vue"
export default component.exports